module.exports = __webpack_public_path__ + "static/media/Illus-Employee_1@3x.2f07be18.png";